import { render, staticRenderFns } from "./ModalCriarEditarOperadoraHospital.vue?vue&type=template&id=a858a9ac"
import script from "./ModalCriarEditarOperadoraHospital.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarOperadoraHospital.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports